import React from 'react'

const size16 = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  fill: 'none'
}

const EyeIcon = () => (
  <svg {...size16} viewBox="2 3 20 18">
    <path
      fill="currentColor"
      d="M12 4c4.984 0 9.13 3.449 10 8-.869 4.551-5.016 8-10 8s-9.13-3.449-10-8c.869-4.551 5.016-8 10-8zm0 14.222a8.534 8.534 0 005.188-1.746A7.972 7.972 0 0020.113 12a7.973 7.973 0 00-2.927-4.471A8.534 8.534 0 0012 5.785 8.534 8.534 0 006.814 7.53 7.973 7.973 0 003.887 12a7.972 7.972 0 002.925 4.476A8.534 8.534 0 0012 18.222zM12 16a4.245 4.245 0 01-2.941-1.172A3.924 3.924 0 017.84 12c0-1.06.438-2.078 1.218-2.828A4.245 4.245 0 0112 8c1.103 0 2.161.421 2.941 1.172A3.924 3.924 0 0116.16 12c0 1.06-.438 2.078-1.218 2.828A4.245 4.245 0 0112 16zm0-1.778c.613 0 1.2-.234 1.634-.65A2.18 2.18 0 0014.31 12a2.18 2.18 0 00-.677-1.571A2.358 2.358 0 0012 9.778c-.613 0-1.2.234-1.634.65A2.18 2.18 0 009.69 12c0 .59.244 1.155.677 1.571.433.417 1.021.651 1.634.651z"
    />
  </svg>
)

const HideEyeIcon = () => (
  <svg {...size16} viewBox="2 3 20 18">
    <path
      fill="currentColor"
      d="M16.893 18.192A8.978 8.978 0 0112 19.637c-4.485 0-8.217-3.293-9-7.637a9.37 9.37 0 012.778-5.147L3.176 4.201 4.353 3l16.47 16.8-1.177 1.2-2.754-2.808h.001zM6.955 8.054A7.641 7.641 0 004.699 12a7.703 7.703 0 001.523 3.159 7.508 7.508 0 002.75 2.126 7.362 7.362 0 006.708-.332l-1.687-1.72a3.685 3.685 0 01-4.642-.531 3.88 3.88 0 01-.52-4.735L6.955 8.054zm5.805 5.921l-2.697-2.75a2.16 2.16 0 00-.1 1.208c.083.404.28.775.566 1.067.286.292.65.492 1.046.577.396.084.808.048 1.184-.102h.001zm6.566 1.921l-1.19-1.213A7.655 7.655 0 0019.3 12a7.715 7.715 0 00-1.249-2.8 7.547 7.547 0 00-2.23-2.07 7.35 7.35 0 00-5.858-.783L8.65 5.008A8.984 8.984 0 0112 4.364c4.485 0 8.217 3.292 9 7.636a9.382 9.382 0 01-1.674 3.896zM11.77 8.19c.53-.034 1.06.048 1.556.24.496.191.946.488 1.322.87.375.383.666.843.854 1.349.187.506.268 1.047.235 1.587l-3.968-4.046z"
    />
  </svg>
)

const CopyIcon = () => (
  <svg {...size16} viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M6 2h6.667A1.333 1.333 0 0114 3.333v8A1.333 1.333 0 0112.667 12.667H12v.666A1.333 1.333 0 0110.667 14.667H3.333A1.333 1.333 0 012 13.333v-8A1.333 1.333 0 013.333 4H4V3.333A1.333 1.333 0 015.333 2H6zm5.333 1.333H5.333V4h5.334A1.333 1.333 0 0112 5.333v6h.667V3.333zM3.333 5.333v8h7.334v-8H3.333z"
    />
  </svg>
)

const GenerateKeyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path
      fill="#202020"
      fillOpacity="0.5"
      d="M8 2.667c.368 0 .667.298.667.666V7.333h4a.667.667 0 010 1.334h-4v4a.667.667 0 01-1.334 0v-4h-4a.667.667 0 010-1.334h4V3.333c0-.368.299-.666.667-.666z"
    />
  </svg>
)

export { EyeIcon, HideEyeIcon, CopyIcon, GenerateKeyIcon }
